<template>
  <el-menu :collapse="isExpand" id="Sidebar" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :default-active="currentMenuIndex" :unique-opened="true">
    <el-submenu index="1" v-if="mainFunList.childs && mainFunList.childs.length>0">
      <template slot="title">
        <i class="el-icon-s-home"></i>
        <span>Major Function </span>
      </template>
      <el-menu-item index="1-1" @click="navTo('landingPage')" v-show="isShowMenu('mainFunList','首页')">Home Page</el-menu-item>
      <el-menu-item index="1-2" @click="navTo('reservation')" v-show="isShowMenu('mainFunList','预定服务总览')">预定服务总览</el-menu-item>
      <el-menu-item index="1-3" @click="navTo('resetPass')" v-show="isShowMenu('mainFunList','重置密码')">重置密码</el-menu-item>
    </el-submenu>
    <el-submenu index="2" v-if="companyMuenList.childs && companyMuenList.childs.length>0">
      <template slot="title">
        <i class="el-icon-s-marketing"></i>
        <span>Company Information</span>
      </template>
      <el-menu-item index="2-1" @click="navTo('company')" v-show="isShowMenu('companyMuenList','企业信息')">企业信息</el-menu-item>
      <el-menu-item index="2-2" @click="navTo('magezine')" v-show="isShowMenu('companyMuenList','会刊信息')">Journal Information</el-menu-item>
      <el-menu-item index="2-3" @click="navTo('product')" v-show="isShowMenu('companyMuenList','展品上传')">Exhibits</el-menu-item>
    </el-submenu>
    <el-submenu index="3" v-if="ztMuenList.childs && ztMuenList.childs.length>0">
      <template slot="title">
        <i class="el-icon-s-ticket"></i>
        <span>我的展台</span>
      </template>
      <el-menu-item index="3-1" @click="navTo('boardInfo')" v-show="isShowMenu('ztMuenList','楣板信息')">楣板信息</el-menu-item>
      
      <template v-if="isShowCode">
          <el-menu-item index="3-2" @click="navTo('inviteCode')" v-show="isShowMenu('ztMuenList','搭建商邀请码')">搭建商邀请码</el-menu-item>
      </template>
     
      <el-menu-item index="3-3" @click="navTo('electric')" v-show="isShowMenu('ztMuenList','用电申请')">用电申请</el-menu-item>
      <el-menu-item index="3-4" @click="navTo('exhibition')" v-show="isShowMenu('ztMuenList','展具租赁')">展具租赁</el-menu-item>
    </el-submenu>

    <el-menu-item index="45" @click="navTo('ExhNotice')" >
      <i class="el-icon-s-help"></i>
      <span slot="title">Exhibitor Notice</span>
    </el-menu-item>

    <el-menu-item index="55" @click="navTo('ServiceBooking')" >
      <i class="el-icon-s-order"></i>
      <span slot="title">Service Booking</span>
    </el-menu-item>

    <el-menu-item index="66" @click="navTo('invitation')" >
      <i class="el-icon-s-shop"></i>
      <span slot="title">Audience Invitation</span>
    </el-menu-item>



    <el-menu-item index="4" @click="navTo('card')" v-if="xkMuenList.perName">
      <i class="el-icon-document"></i>
      <span slot="title">Exhibitor Badges</span>
    </el-menu-item>
    <el-menu-item index="7" @click="navTo('lzCode')" v-if="lzmMuenList.perName">
      <i class="el-icon-document"></i>
      <span slot="title">自助领证码</span>
    </el-menu-item>
    <el-menu-item index="5" @click="navTo('activityList')" v-if="atyMuenList.perName">
      <i class="el-icon-setting"></i>
      <span slot="title">活动列表</span>
    </el-menu-item>

    <el-submenu index="6" v-if="cooperaMuenList.childs && cooperaMuenList.childs.length>0">
      <template slot="title">
        <i class="el-icon-s-ticket"></i>
        <span>合作服务</span>
      </template>
      <el-menu-item index="6-1" @click="navTo('adBook')" v-show="isShowMenu('cooperaMuenList','广告申请')">广告申请</el-menu-item>   
    </el-submenu>
  </el-menu>
</template>

<script>
import api from '@/api'
export default {
  data() {
    return {
      currentMenuIndex: this.$route.meta.menuIndex.toString(),
      userInfo: {},
      isShowCode:false,
      mainFunList:{},
      companyMuenList: {},
      ztMuenList: {},
      xkMuenList: {},
      atyMuenList: {},
      lzmMuenList: {},
      cooperaMuenList: {}
    }
  },
  created() {
    this.initDashboard()
  },

  mounted() {
    this.getmenulist()
  },

  watch: {},
  computed: {
    isExpand() {
      return this.$store.state.status.isExpand
    },
    // 控制显示的菜单
    isShowMenu() {
      return function(_arr,str) {
        var _arrList = this[_arr]
        if(_arrList.childs){
          for(var i = 0; i<_arrList.childs.length;i++){
              if( _arrList.childs[i].perName == str){
                return true
              }
          }
          return false
        }else{
          return false
        }
      }
    }
  },
  methods: {
    getmenulist() {
      api.getmenulist().then(res => {
        if (res.data.code === 200) {
          var menulist = res.data.data
          for(var i=0;i<menulist.length;i++){
            if(menulist[i].perName == '主要功能'){
              this.mainFunList = menulist[i]
            }
            if(menulist[i].perName == '公司信息'){
              this.companyMuenList = menulist[i]
            }
            if(menulist[i].perName == '我的展台'){
              this.ztMuenList = menulist[i]
            }

            if(menulist[i].perName == '胸卡申请'){
              this.xkMuenList = menulist[i]
            }
            if(menulist[i].perName == '自助领证码'){
              this.lzmMuenList = menulist[i]
            }
            if(menulist[i].perName == '活动列表'){
              this.atyMuenList = menulist[i]
            }

            if(menulist[i].perName == '合作服务'){
              this.cooperaMuenList = menulist[i]
            }
          }
        }
      })
    },
    navTo(name) {
      if (this.$route.name === name) {
        return false
      }
      this.$router.push(`/${name}`)
    },
    initDashboard() {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let duration = ''

      if (!this.userInfo) {
        this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
        return
      }

      if (this.userInfo.loginTime === '') {
        this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
        return
      }
      if( this.userInfo && this.userInfo.bthBigType=='RS' ){
          this.isShowCode = true
      }
      duration = (new Date().getTime() - this.userInfo.loginTime) / 1000 / 60 / 60
      // 登陆超过20小时后超时
      if (duration > 20) {
        this.$alert('超时，请重新登录', '', {
          confirmButtonText: '确定',
          callback: (action) => {
            localStorage.removeItem('userInfo')
            this.$router.push('/login?ExhID='+localStorage.getItem("ExhID"))
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
#Sidebar {
  padding-top: 60px;
  height: 100%;
  &:not(.el-menu--collapse) {
    width: 200px;
  }
}
@media screen and (max-width:540px){
  // #Sidebar {
  //   position: fixed;
  //   z-index: 10
  // }
}
</style>
